import { b as __rest, a as __assign } from '../../../../tslib.es6-a39f91fc.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { c as classNames } from '../../../../index-6ea95111.js';
import { s as styleInject } from '../../../../style-inject.es-1f59c1d0.js';
import { BaseCell } from './BaseCell/BaseCell.js';
import { CTACell } from './CTACell/CTACell.js';
import { CardCell } from './CardCell/CardCell.js';
import { ButtonCell } from './ButtonCell/ButtonCell.js';
import React__default from 'react';
import '../../../icon/icons/CheckThick.js';
import '../../../icon/IconWrapper/IconWrapper.js';
import '../../../icon/icons/StarFilled.js';
import '../../../icon/icons/X.js';
import '../../../icon/icons/ZapFilled.js';
import './BaseCell/MiniProgressBar/MiniProgressBar.js';
import '../../../../index-af1860d8.js';
import '../../../../_commonjsHelpers-4730bd53.js';
import '../../../comparisonTable/components/TableInfoButton/index.js';
import '../../../icon/icons/Info.js';
import '../../../../index-5e72c3d4.js';
import '../IconRenderer/IconRenderer.js';
import '../../../cards/card/index.js';
import '../../../icon/icons/ChevronRight.js';
import '../../../button/index.js';

var css_248z = ".TableCell-module_th__2rjCU {\n  vertical-align: middle;\n  scroll-snap-align: end;\n  width: 50%;\n}\n@media (min-width: 34rem) {\n  .TableCell-module_th__2rjCU {\n    width: auto;\n    scroll-snap-align: unset;\n  }\n}\n.TableCell-module_thNavigation__qZ2sY {\n  width: 100%;\n}\n@media (min-width: 34rem) {\n  .TableCell-module_thNavigation__qZ2sY {\n    width: auto;\n  }\n}\n\n.TableCell-module_fixedCell__cL3-m {\n  position: sticky;\n  left: 0;\n  z-index: 2;\n}\n.TableCell-module_fixedCell__cL3-m:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 1px;\n  background-color: #f5f6fb;\n}\n\n.TableCell-module_fixedCard__2LO8s {\n  position: sticky;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  width: 100%;\n}";
var styles = {"th":"TableCell-module_th__2rjCU","thNavigation":"TableCell-module_thNavigation__qZ2sY","fixedCell":"TableCell-module_fixedCell__cL3-m","fixedCard":"TableCell-module_fixedCard__2LO8s"};
styleInject(css_248z);

var TableCell = React__default.memo(function (_a) {
    var _b;
    var _c;
    var _d = _a.isFirstCellInRow, isFirstCellInRow = _d === void 0 ? false : _d, _e = _a.isHeader, isHeader = _e === void 0 ? false : _e, _f = _a.isNavigation, isNavigation = _f === void 0 ? false : _f, _g = _a.isTopLeftCell, isTopLeftCell = _g === void 0 ? false : _g, _h = _a.colSpan, colSpan = _h === void 0 ? 0 : _h, isBelowDesktop = _a.isBelowDesktop, cellProps = __rest(_a, ["isFirstCellInRow", "isHeader", "isNavigation", "isTopLeftCell", "colSpan", "isBelowDesktop"]);
    // prettier-ignore
    var Tag = isNavigation
        ? 'div'
        : isHeader || isFirstCellInRow ? 'th' : 'td';
    // prettier-ignore
    var thScope = isHeader
        ? 'col'
        : isFirstCellInRow ? 'row' : undefined;
    var scope = {
        scope: thScope,
    };
    return (jsxs(Tag, __assign({}, scope, { className: classNames('bg-white py24 px8', styles.th, (_b = {
                'ta-left': isFirstCellInRow
            },
            _b[styles.thNavigation] = isNavigation,
            _b[styles.fixedCell] = isFirstCellInRow && colSpan < 1,
            _b[styles.fixedCard] = cellProps.type === 'CARD',
            _b.pl16 = isFirstCellInRow,
            _b)), colSpan: isBelowDesktop && cellProps.type === 'CARD' ? 2 : colSpan, children: [!cellProps.type && (jsx(BaseCell, __assign({}, cellProps, { fontVariant: isTopLeftCell
                    ? 'BIG_WITH_UNDERLINE'
                    : (_c = cellProps.fontVariant) !== null && _c !== void 0 ? _c : 'NORMAL' }))), cellProps.type === 'CTA' && jsx(CTACell, __assign({}, cellProps)), cellProps.type === 'BUTTON' && jsx(ButtonCell, __assign({}, cellProps)), cellProps.type === 'CARD' && jsx(CardCell, __assign({}, cellProps))] })));
});

export { TableCell };
//# sourceMappingURL=TableCell.js.map
